function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "presentation"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#44484c"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "9.1",
  cy: "8.6",
  r: "5.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1 12.8l3.9 3.8"
})));